const toggleParam = ({ name, value }, result) => {
  if (value) {
    result[name] = value

    return result
  }

  if (result.hasOwnProperty(name)) {
    delete result[name]
  }

  return result
}

export default {
  methods: {
    toggleQuery (queries) {
      let resultQuery = { ...this.$route.query }

      if (Array.isArray(queries)) {
        queries.forEach(item => {
          resultQuery = toggleParam(item, resultQuery)
        })

        return this.$router.push({ query: resultQuery }).catch(() => {})
      }

      if (queries.isMultiple) {
        if (queries.value) {
          if (queries.isRemoveValue) {
            resultQuery[queries.name] = resultQuery[queries.name].filter(el => el !== queries.value.toString())
          } else {
            if (Array.isArray(resultQuery[queries.name])) {
              resultQuery[queries.name] = [...resultQuery[queries.name], queries.value.toString()]
            } else {
              if (resultQuery[queries.name]) {
                resultQuery[queries.name] = [resultQuery[queries.name], queries.value.toString()]
              } else {
                resultQuery[queries.name] = [queries.value.toString()]
              }
            }
          }
        } else {
          resultQuery[queries.name] = []
        }
      } else {
        resultQuery = toggleParam(queries, resultQuery)
      }

      const promise = this.$router.push({ query: resultQuery })

      if (!promise) return

      promise.catch(() => {})
    }
  }
}
